export default __webpack_public_path__ + "static/media/payment-method-apple-pay-grey-icon.1175c477.svg";